import React from 'react'
import { Link } from 'react-router-dom'
import abuso_sustancias from '../assets/images/psicologo/abuso_sustancias.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg2 from '../assets/images/Brochure_Deymed_Duomag/3.png'
import bg1 from '../assets/images/bg.jpg'
import bg_rehacom from '../assets/images/Brochure_RehaCom/83.jpg'
import { casesData } from '../data'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg_rehacom})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">RehaCom</h4>
                          <p className="text-muted mb-0">Definición, objetivo y aplicación</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Servicios</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">RehaCom</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>
    <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>      
      <div className="col-12">
        <h4>Definición</h4>
        <p className="text-muted">
          RehaCom es un sistema de rehabilitación cognitiva asistida por computadora, diseñado para la neurorehabilitación. Su principal objetivo es entrenar y mejorar las funciones cognitivas que han sido afectadas por una lesión cerebral o una enfermedad neurológica. A través de ejercicios específicos, el software busca generar neuroplasticidad, que es la capacidad del cerebro para reorganizarse y formar nuevas conexiones neuronales, permitiendo la recuperación de las funciones perdidas.
        </p>
        <br />
        <h4 className='text-warning'>Objetivo</h4>
        <p className="text-muted">
        El objetivo de la terapia se enfoca en la rehabilitación de déficits cognitivos causados por afecciones como:         
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
         Accidente cerebrovascular (ictus), traumatismo craneoencefálico, esclerosis múltiple, enfermedad de alzheimer, otros trastornos neurológicos y psiquiátricos.
        </p>
        
         <p className="text-muted">
        RehaCom está compuesto por numerosos módulos (más de 25) diseñados para trabajar déficits cognitivos específicos. Algunos de los módulos más comunes se centran en:
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
       Atención (atención dividida, atención y concentración, alerta),  memoria (memoria a corto plazo, memoria verbal, memoria de trabajo), funciones ejecutivas (planificación, razonamiento lógico) percepción y orientación (habilidades visomotoras, campo visual) y habilidades de la vida diaria.
        </p>
            <br />
         <h4>Aplicación clínica</h4>
          <p className="text-muted">
             <i className="mdi mdi-chevron-double-right me-2"></i>
          Una de las características clave de RehaCom es su capacidad para adaptarse automáticamente al rendimiento del paciente. El software mide el tiempo de reacción, el número de errores y otros parámetros para ajustar el nivel de dificultad en tiempo real. Esto asegura que el paciente siempre esté trabajando en un nivel de dificultad apropiado, lo que mantiene la motivación y optimiza los resultados.
        </p>
        <p className="text-muted">
             <i className="mdi mdi-chevron-double-right me-2"></i>
          Es utilizado por neuropsicólogos, terapeutas ocupacionales y otros profesionales en hospitales, clínicas de rehabilitación y consultas privadas.
        </p>
          <p className="text-muted">
             <i className="mdi mdi-chevron-double-right me-2"></i>
          La terapia puede comenzar en un entorno clínico y, en muchos casos, puede continuarse en casa bajo la supervisión remota de un terapeuta.
        </p>
           <br />
        <h4>Conclusión</h4>
        <p className="text-muted">
          En resumen, aunque RehaCom no es un equipo de neuromodulación en el sentido de aplicar estímulos externos, es una herramienta fundamental en la neurorehabilitación. Su propósito es modular la actividad cerebral a través de la estimulación cognitiva intensa y personalizada, aprovechando la neuroplasticidad del cerebro para recuperar y mejorar las funciones afectadas.
        </p>
      </div>
    </div>
    
        <div className="justify-content-center" style={{textAlign:'justify', paddingLeft:20, paddingRight:20}}>      
            <div className="col-12">
                  <p className="text-muted">
                   Imagenes del Software:
                </p>
                <div className='row'>
                {casesData.map((item,index)=>{
                  return(
                      <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                          <div className="cases border rounded position-relative overflow-hidden">
                              <Link to="#"><img src={item.image} className="img-fluid" alt=""/></Link>
                              <div className="content p-4">
                                  <h5><Link to="#" className="title text-dark">{item.name}</Link></h5>
                                  <small className="h6 text-muted mb-0">{item.title}</small>
                              </div>
                          </div>
                      </div>
                  )
                })}
              </div>
              </div> 
              </div>
  </div>
</section>
    <Footer/>
    </>
  )
}
